<script>
  import { slide } from "svelte/transition";

  export let isShow: boolean = false;

  const toggle = () => (isShow = !isShow);
</script>

<div class="accordion" class:active={isShow}>
  <div class="accordion-title">
    <button on:click={toggle}>
      <div class="accordion-button" tabindex="-1">
        <slot name="title" />
        <div class="arrow-icon" class:isShow />
      </div>
    </button>
  </div>
  {#if isShow}
    <div class="answer" transition:slide>
      <slot name="content" />
    </div>
  {/if}
</div>

<style>
  .accordion-title {
    :global(button) {
      display: block;
      width: 100%;
      text-align: left;
    }
  }
  .accordion-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-right: 16px;

    &:focus {
      outline: none;
    }
  }
  .arrow-icon {
    position: relative;
    min-width: 12px;
    width: 12px;
    height: 12px;
    border: 2px solid $key-color;
    border-width: 2px 2px 0 0;
    transform: rotate(135deg);
    top: -3px;
    margin-left: 16px;

    &.isShow {
      transform: rotate(-45deg);
      top: 3px;
    }

    @include sm {
      min-width: 16px;
      width: 16px;
      height: 16px;
      border-width: 3px 3px 0 0;
    }
  }
</style>
